import React, { useContext, useState } from "react";
import {
  IconDelete,
  IconForbidden,
  IconMinus,
  IconPlus,
} from "../../../../assets/icons";
import LoaderDot from "../../../components/LoaderDot";
import { BasketHelper } from "../../../../core/utils/BasketHelper";
import ContextApp from "../../../../core/contexts/context.app";
import ApiBasket from "../../../../core/api/api.basket";
import _ from "lodash";

function CounterButton({ item, totalCount, basket }) {
  const [loaderDot, setLoaderDot] = useState(false);
  const ctx = useContext(ContextApp);
  const [minMaxIsUpdated, setMinMaxIsUpdated] = useState(false);
  const increment = async (item) => {
    if (!minMaxIsUpdated || totalCount < item.maxReserveCount)
      changeBasket(item, totalCount + 1);
  };

  const decrement = async (item) => {
    changeBasket(item, totalCount - 1);
  };

  async function changeBasket(item, basketItemCount) {
    try {
      if (!loaderDot) {
        setLoaderDot(true);
      }
      await BasketHelper.changeBasketItemTotalCount(
        ctx,
        item,
        basketItemCount,
        minMaxIsUpdated
      );
      setMinMaxIsUpdated(true);
      setLoaderDot(false);
    } catch (error) {
      setLoaderDot(false);
    }
  }
  return (
    <div
      className="small-svg-1 border d-inline-block bg-white d-flex align-items-center py-auto rounded-2"
      style={{
        height: "42px",
      }}
    >
      <button
        className="btn px-2 mx-0 btn-no-style basket-plus-button"
        onClick={() => increment(item)}
        disabled={
          loaderDot || (minMaxIsUpdated && totalCount >= item.maxReserveCount)
        } // شرط اصلاح‌شده برای مقایسه
      >
        {loaderDot ||
        (minMaxIsUpdated && totalCount >= item.maxReserveCount) ? (
          <IconForbidden fillColor="#f80248" />
        ) : (
          <IconPlus fillColor="#f80248" />
        )}
      </button>

      <span
        className="d-inline-block text-center fw-bold px-0 mb-1 position-relative h-100"
        style={{ width: "52px" }}
      >
        <div className="mt-2 d-flex justify-content-center">
          {loaderDot ? (
            <LoaderDot />
          ) : (
            <span className="text-danger">{totalCount}</span>
          )}
        </div>
        <div
          className="fs-062 mb-1 text-black-06 position-absolute"
          style={{
            right: "50%",
            marginRight: "-27px",
            top: "69%",
            width: "50px",
          }}
        >
          تعداد بلیط
        </div>
      </span>

      <button
        className="px-2 mx-0 btn btn-no-style"
        onClick={() => decrement(item)}
        disabled={loaderDot}
      >
        {(minMaxIsUpdated && totalCount <= item.minReserveCount) ||
        totalCount == 1 ? (
          <IconDelete fillColor="#f80248" />
        ) : (
          <IconMinus fillColor="#f80248" />
        )}
      </button>
    </div>
  );
}

export default CounterButton;
